<section>
  <img src="/assets/images/Fault.png" alt="Warning Icon" class="icon" />
  <div class="text">
    <p>{{ errorDetail }}</p>
  </div>
</section>
